export default {
    get(name) {
        return localStorage.getItem(name);
    },
    set(name, value) {
        localStorage.setItem(name, value);
    }
}


// WEBPACK FOOTER //
// ./src/util/cache.js